import { Component, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PopoverService } from 'app/core/services/popover.service';
import { PartySignupTabsService } from 'app/manage-party-signup/services/party-signup-tabs.service';
import { MdbPopoverDirective, MdbPopoverModule } from 'mdb-angular-ui-kit/popover';

let id = 1;
@Component({
  selector: 'app-party-signup-tabs-popover',
  standalone: true,
  imports: [MdbPopoverModule],
  templateUrl: './party-signup-tabs-popover.component.html',
  styleUrl: './party-signup-tabs-popover.component.scss'
})
export class PartySignupTabsPopoverComponent {
   @Input() public signupCampaign: any;
  
    constructor(
      private popoverService:PopoverService,
      private router: Router,
      private tabsService:PartySignupTabsService
    )
    {}
  
    @ViewChild('popover') popover: MdbPopoverDirective = null;
    private _id = id++;
    
    get id() {
      return `PartysignuptabsPopover${this._id}`;
    }
      
    onPopoverShown(): void {
      this.popoverService.list[this.id] = this.popover;
      const self = this;

      window["$"](window).one('click', function() {
        self.popover.hide()
        delete self.popoverService.list[self.id];
      });
    }
  
    onPopoverHidden(): void {
      delete this.popoverService.list[this.id];
    }
  
    openPartysignupDetailsPage(event, tabName){
      if(!event.target.matches('.noDetaisClick')){
        this.tabsService.selectedTab = tabName;
        this.router.navigate(['manage/party-signup', this.signupCampaign.id], { fragment: `${ tabName }Tab` });
      }
    }
}
